import { render, staticRenderFns } from "./pageModal.vue?vue&type=template&id=c6f17988&scoped=true&"
import script from "./pageModal.vue?vue&type=script&lang=js&"
export * from "./pageModal.vue?vue&type=script&lang=js&"
import style0 from "./pageModal.vue?vue&type=style&index=0&id=c6f17988&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f17988",
  null
  
)

export default component.exports